"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DevDbService = void 0;
const service_1 = require("./service");
const devDbMapper_1 = require("../utils/devDbMapper");
class DevDbService extends service_1.Service {
    constructor(transport, auth) {
        super(transport, auth);
    }
    /**
     * Get list of brands for a category
     * @param category usually 'phones', 'ebook', 'pad', 'smartwatch'
     */
    async getBrands(category) {
        const response = await this.transport.send('dt', [category]);
        this.checkError(response, 'dt');
        const data = response.data;
        // Data format can be: [[Brands]] or [CatSlug, CatName, [Brands]]
        let brandsList = data[0];
        if (typeof brandsList === 'string' && Array.isArray(data[2])) {
            brandsList = data[2];
        }
        return devDbMapper_1.DevDbMapper.mapBrands(brandsList);
    }
    /**
     * Get list of devices for a brand
     */
    async getDevices(category, brand) {
        const response = await this.transport.send('dv', [category, brand]);
        this.checkError(response, 'dv');
        return devDbMapper_1.DevDbMapper.mapDevices(response.data);
    }
    /**
     * Get device details
     */
    async getDevice(deviceId) {
        const response = await this.transport.send('de', [deviceId]);
        this.checkError(response, 'de');
        return devDbMapper_1.DevDbMapper.mapDeviceDetail(response.data);
    }
    /**
     * Add device to 'My Devices' (shown in profile)
     */
    async addMyDevice(deviceId) {
        const userId = this.auth?.userId || 0;
        const res = await this.transport.send('md', [userId, 1, deviceId, 0]);
        this.checkError(res, 'md');
    }
    /**
     * Remove device from 'My Devices'
     */
    async removeMyDevice(deviceId) {
        const userId = this.auth?.userId || 0;
        const res = await this.transport.send('md', [userId, 0, deviceId, 0]);
        this.checkError(res, 'md');
    }
}
exports.DevDbService = DevDbService;
